import { STEPS } from '../constants/steps.js'
import { useAuthAccessibility } from '../../shared/composables/useAuthAccessibility.js'

const STEP_ANNOUNCEMENTS = {
  [STEPS.IDENTIFIER]: 'Sign in. Enter your phone number or email address.',
  [STEPS.SIGN_IN_METHOD]: 'Choose how you would like to sign in.',
  [STEPS.MAGIC_LINK_SENT]: 'Magic link sent. Check your inbox.',
  [STEPS.PASSWORD]: 'Enter your password.',
  [STEPS.FORGOT_PASSWORD]: 'Reset your password.',
  [STEPS.RESET_LINK_SENT]: 'Password reset link sent. Check your messages.',
  [STEPS.SET_PASSWORD_FROM_LINK]: 'Set your new password.',
  [STEPS.CHOOSE_METHOD]: 'Choose how to receive your verification code.',
  [STEPS.VERIFY]: 'Enter your verification code.',
  [STEPS.CLASSIC_PHONE]: 'Enter your mobile phone number.',
  [STEPS.CLASSIC_PASSWORD]: 'Enter your email and password.',
  [STEPS.CLASSIC_VERIFY]: 'Enter the verification code sent to your phone.',
}

export function useLoginAccessibility(currentStep, stepError) {
  return useAuthAccessibility(currentStep, stepError, STEP_ANNOUNCEMENTS)
}
